module.exports = __webpack_public_path__ + "img/Bank BTPN Syariah.311eb278.png";